import type { RefObject } from 'react';
import { Stack } from '@etg/wings';
import { useHeightContext, useProperty } from '@eti/providers';
import type { TripRoute } from '@eti/schema-types';
import StickySidebar from '../../../../../widgets/sidebar/components/StickySidebar';
import FloatingSaveTripButton from '../../v3/FloatingSaveTripButton';
import type { ResultSetMetaDataType } from '../../../models';
import type { Filters } from './MobileFilters';
import DesktopSidebarFilters from './DesktopSidebarFilters';
import DesktopDrawerFilters from './DesktopDrawerFilters';

interface DesktopFiltersProps {
  filteredFlightsCount: number;
  flightsCount: number;
  isOpen: boolean;
  onClear: () => void;
  onDone: () => void;
  onFilter: (filter: any) => void;
  resultSetMetaData: ResultSetMetaDataType;
  selectedFilters?: Filters;
  searchRoutes: TripRoute[];
  sidebarRef: RefObject<HTMLElement>;
}

const DesktopFilters = ({
  filteredFlightsCount,
  flightsCount,
  isOpen,
  onClear,
  onDone,
  onFilter,
  resultSetMetaData,
  searchRoutes,
  selectedFilters,
  sidebarRef,
}: DesktopFiltersProps) => {
  const { p } = useProperty();
  const isDrawerEnabled = p('Result.Page.V3.DesktopDrawerSearchResultFilters.Enabled');

  const { headerHeightContext } = useHeightContext();

  return isDrawerEnabled ? (
    <DesktopDrawerFilters
      filteredFlightsCount={filteredFlightsCount}
      isOpen={isOpen}
      onClear={onClear}
      onDone={onDone}
      onFilter={onFilter}
      resultSetMetaData={resultSetMetaData}
      searchRoutes={searchRoutes}
      selectedFilters={selectedFilters}
    />
  ) : (
    <StickySidebar containerRef={sidebarRef} topSpacing={headerHeightContext}>
      <Stack spacing={16}>
        <FloatingSaveTripButton />
        <DesktopSidebarFilters
          filteredFlightsCount={filteredFlightsCount}
          flightsCount={flightsCount}
          onClear={onClear}
          onFilter={onFilter}
          resultSetMetaData={resultSetMetaData}
          searchRoutes={searchRoutes}
          selectedFilters={selectedFilters}
        />
      </Stack>
    </StickySidebar>
  );
};

export default DesktopFilters;
